import { failureAction, successAction, startAction } from '../../common'
import { GET_USER_PROFILE } from '../types'

export const initialState = {
  loading: false,
  loaded: false,
  error: {},
  data: {},
}

const reducer = ({ profile: state }, action) => {
  switch (action.type) {
    case startAction(GET_USER_PROFILE):
      return {
        ...state,
        loading: true,
        loaded: false,
      }
    case successAction(GET_USER_PROFILE):
      return {
        ...state,
        loading: false,
        loaded: true,
        error: {},
        data: action.payload,
      }
    case failureAction(GET_USER_PROFILE):
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.payload,
        data: {},
      }

    default:
      return state
  }
}

export default reducer
